import React, { Component } from "react";
import { selectUserToken } from "../../util/selectors";
import { connect } from "react-redux";
import SettingForm from "./components/SettingForm";
import { loadProfileData, updateProfileData } from "./actions";
import { connectSaga } from "../../util/hoc/connectSaga";
import { watchProfileSettingsRequests } from "./sagas";
import { push, goBack } from "redux-little-router";

import "./index.css";

class SettingsPage extends Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
  }
  componentDidMount() {
    this.props.loadProfileData();
  }
  onCancel() {
    if (this.props.prevRoute) {
      this.props.goBack();
    } else {
      this.props.push("/");
    }
  }
  render() {
    return (
      <div className="settings page">
        <h2>Edit Profile </h2>
        <SettingForm
          onSubmit={formData => this.props.updateProfileData(formData)}
          onCancel={this.onCancel}
          {...this.props}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  accessToken: selectUserToken(state),
  isLoading: !(state.form.settingsForm && state.form.settingsForm.initial),
  prevRoute: state.router.previous,
});

const mapDispatchToProps = dispatch => ({
  loadProfileData: () => dispatch(loadProfileData()),
  updateProfileData: profileData => dispatch(updateProfileData(profileData)),
  goBack: () => dispatch(goBack()),
  push: route => dispatch(push(route)),
});

export default connect(mapStateToProps, mapDispatchToProps)(connectSaga(SettingsPage, watchProfileSettingsRequests));



// WEBPACK FOOTER //
// ./src/scenes/EditProfilePage/index.js